"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Background = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Image = styled_components_1.default.div `
  position: relative;
  height: calc(100vh - 21px);
  width: 100%;
  padding: 0;
  margin: 0;
  background: grey;

  background-image: url("${props => props.url}");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
`;
const ChildWrapper = styled_components_1.default.div `
   padding-top: 20px;
   padding-bottom: 20px;
   margin-left: auto;
   margin-right: auto;
   width: 300px;
`;
const getRandomBackgroundImageNumber = () => {
    const min = 1;
    const max = 9;
    return Math.floor(Math.random() * (max - min + 1) + min);
};
exports.Background = (props) => {
    // eslint-disable-next-line
    let backgroundUrl = require(`../backgrounds/${getRandomBackgroundImageNumber()}.jpg`);
    return (react_1.default.createElement(Image, { url: backgroundUrl },
        react_1.default.createElement(ChildWrapper, null, props.children)));
};
//# sourceMappingURL=Background.js.map